import * as React from "react";
import { useTranslation } from "react-i18next";
import CreateHealthAlertButton from "./alert/CreateHealthAlertButton";
import HealthStatusIcon from "./HealthStatusIcon";
import { getStatusDescription, getStatusLabel, STATUS_ORDER } from "./healthStatusCopy";
import {
  BodyText,
  DetailsTitle,
  DetailsTitleRow,
  InterpretationPane,
  InterpretationTitle,
  LegendItem,
  LegendList,
  LegendText,
  StatusSummary
} from "./HealthModule.styles";
const HealthInterpretationLegend = ({ root, path, onCreateAlert }) => {
  const { t } = useTranslation("enterprise_license");
  return /* @__PURE__ */ React.createElement(InterpretationPane, null, /* @__PURE__ */ React.createElement(DetailsTitleRow, null, /* @__PURE__ */ React.createElement(DetailsTitle, null, root.title), /* @__PURE__ */ React.createElement(CreateHealthAlertButton, { onClick: () => onCreateAlert(root, path) })), /* @__PURE__ */ React.createElement(StatusSummary, null, /* @__PURE__ */ React.createElement(HealthStatusIcon, { status: root.status, title: getStatusLabel(root.status) }), /* @__PURE__ */ React.createElement("span", null, getStatusLabel(root.status))), /* @__PURE__ */ React.createElement(InterpretationTitle, null, t("health.legend.title")), /* @__PURE__ */ React.createElement(BodyText, null, t("health.legend.intro")), /* @__PURE__ */ React.createElement(LegendList, null, STATUS_ORDER.map((status) => /* @__PURE__ */ React.createElement(LegendItem, { key: status }, /* @__PURE__ */ React.createElement(HealthStatusIcon, { status, title: getStatusLabel(status) }), /* @__PURE__ */ React.createElement(LegendText, null, /* @__PURE__ */ React.createElement("strong", null, getStatusLabel(status), ":"), " ", getStatusDescription(status))))));
};
export default HealthInterpretationLegend;
